import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getCapacidades = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/capacidades?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getCapacidadesTipo = async (codigo) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/capacidades/tipo?empresa=${userInfo.empresa}&codigo=${codigo}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearCapacidad = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/capacidades', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateCapacidad = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/capacidades/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteCapacidad = (Id) => Axios.delete(`/capacidades/${Id}`);